module.exports = __webpack_public_path__ + "img/ratify-logo.f8dd96aa.svg";